import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CommonQueryService } from '../main/content/apps/queryFiles';
import { environment } from '../../environments/environment';

@Injectable()
export class PermissonCheckGuard implements CanActivate {
  roleId: any;
  userId: any;
  constructor(
    private _router: Router,
    public commonQueryService: CommonQueryService
  ) {
    this.roleId = window.localStorage.getItem('roleId');
    this.userId = window.localStorage.getItem('userUID');
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let hasAccess = next && next.routeConfig && next.routeConfig.path && environment.ownerRoleId !== this.roleId && environment.executiveRoleId !== this.roleId;
    if (false) {
      this.commonQueryService.FETCH_MENU_BY_ROLE_PERMISSION_CALL(this.roleId, next.routeConfig.path, this.userId).valueChanges.subscribe((menuRes: any) => {

        let menuData = menuRes && menuRes.data && menuRes.data.allMenuItems && menuRes.data.allMenuItems.nodes && menuRes.data.allMenuItems.nodes.length > 0 ? menuRes.data.allMenuItems.nodes : [];

        let menuRoleData = menuData.length > 0 && menuData[0].userMenuPermissionsByMenuItemId && menuData[0].userMenuPermissionsByMenuItemId.nodes && menuData[0].userMenuPermissionsByMenuItemId.nodes.length > 0 ? menuData[0].userMenuPermissionsByMenuItemId.nodes : [];

        if (menuRoleData.length > 0) {
          setTimeout(() => {
            this._router.navigate([state.url]);
          }, 1000);
        } else {
          setTimeout(() => {
            this._router.navigate(['apps/404']);
          }, 1000);
        }
      })
    } else {
      setTimeout(() => {
        this._router.navigate([state.url]);
      }, 1000);

    }

    return true;

  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/guard/permisson-check.guard.ts